import { InjectionToken, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShoppingcartComponent } from './shoppingcart.component';
import { MatIconModule } from '@angular/material/icon';
import { LanguageModule } from '../language/language.module';
import { RouterModule } from '@angular/router';
import { CartsumComponent } from './cartsum/cartsum.component';
import { ContactComponent } from './contact/contact.component';
import { TranslationModule } from '../translation/translation.module';
import { CartsummaryComponent } from './cartsummary/cartsummary.component';
import { TypeofpaymentComponent } from './typeofpayment/typeofpayment.component';
import { TypeofdeliveryComponent } from './typeofdelivery/typeofdelivery.component';
import { ShoppingcartPopupComponent } from './shoppingcart-popup/shoppingcart-popup.component';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProgressBarComponent } from './progress-bar/progress-bar.component';
import { OrderConfirmationComponent } from './order-confirmation/order-confirmation.component';
import { PaymentstatusComponent } from './paymentstatus/paymentstatus.component';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import {MAT_RADIO_DEFAULT_OPTIONS, MatRadioModule} from '@angular/material/radio';
import { FoxpostpopupComponent } from './foxpostpopup/foxpostpopup.component';
import { RemovepackagepopupComponent } from './removepackagepopup/removepackagepopup.component';
import { MatCheckboxModule} from '@angular/material/checkbox';







@NgModule({
    declarations: [ShoppingcartComponent, CartsumComponent, ContactComponent, CartsummaryComponent,TypeofdeliveryComponent,TypeofpaymentComponent, ShoppingcartPopupComponent, ProgressBarComponent, OrderConfirmationComponent, PaymentstatusComponent, LoadingSpinnerComponent, FoxpostpopupComponent, RemovepackagepopupComponent],
    exports: [ShoppingcartComponent,CartsumComponent,ContactComponent,CartsummaryComponent,TypeofdeliveryComponent,TypeofpaymentComponent, ProgressBarComponent, OrderConfirmationComponent, PaymentstatusComponent, LoadingSpinnerComponent],
    imports: [CommonModule,FormsModule, MatIconModule, LanguageModule, RouterModule, TranslationModule, MatDialogModule,MatCheckboxModule,MatRadioModule, ReactiveFormsModule],
    providers: [
        {
            provide: MAT_DIALOG_DEFAULT_OPTIONS,
            useValue: { hasBackdrop: true }
        },
        {
        provide: MAT_RADIO_DEFAULT_OPTIONS,
        useValue: { color: 'black' }
        }



    ]
})
export class ShoppingcartModule {


}
